export default __webpack_public_path__ + "static/media/email-sent-illustration.9ee6009e.svg";